import moment from 'moment'

export const extractMonth = date => {
  const y = date.year
  const m = date.month
  const beginningOfMonth = moment(
    new Date(y, m.index, 1, 0, 0, 0, 0).toISOString()
  ).format('YYYY-MM-DD HH:mm:ss')
  const endOfMonth = moment(
    new Date(y, m.index, m.length, 23, 59, 59, 999).toISOString()
  ).format('YYYY-MM-DD HH:mm:ss')
  return { beginningOfMonth, endOfMonth }
}

export const extractDayRange = date => {
  const baseDate = moment(date)

  return {
    beginningOfDay: baseDate.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    endOfDay: baseDate.endOf('day').format('YYYY-MM-DD HH:mm:ss')
  }
}

export const formatDateLabel = dateString => {
  const date = moment(dateString, 'YYYY-MM-DD')
  if (date.isSame(moment(), 'day')) {
    return 'Hoje'
  } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
    return 'Ontem'
  } else {
    return date.format('LL')
  }
}
